module.exports = __webpack_public_path__ + "static/media/ill_magbesvar_nedre.40f19030.svg";